<template>
    <header>
        <b-navbar toggleable="md" :class="{'logged-in': $auth.isAuthenticated}">
            <b-container>
                <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
                <b-navbar-brand href="https://www.gmvoices.com">
                    <img src="/images/logo.svg" />
                </b-navbar-brand>


                <b-collapse is-nav id="nav_collapse">
                    <b-navbar-nav class="ml-auto">
                        <b-nav-item :href="'https://' + website_url + '/media/listen'"><font-awesome-icon icon="microphone" /> Voice Catalog</b-nav-item>
                        <b-nav-item v-if="!isAuthenticated && $route.name !== 'brief'" :to="{ name: 'login' }"><font-awesome-icon icon="user" /> Login</b-nav-item>
                        <b-nav-item-dropdown right no-caret v-if="isAuthenticated">
                            <template slot="button-content">
                                <div class="img-avatar">
                                    <font-awesome-icon icon="user" />
                                </div>
                            </template>
                            <b-dropdown-header tag="div" class="text-center"><strong>{{user.first_name}} {{user.last_name}}</strong></b-dropdown-header>
                            <b-dropdown-item :to="{name: 'account'}" ><font-awesome-icon icon="user" /> Account</b-dropdown-item>
                            <b-dropdown-item :to="{name: 'projects'}"><font-awesome-icon icon="clipboard-list" /> Projects</b-dropdown-item>
                            <b-dropdown-item :to="{name: 'orders'}"><font-awesome-icon icon="file-invoice" /> Order History</b-dropdown-item>
                            <b-dropdown-item @click="logout()"><font-awesome-icon icon="lock" /> Logout</b-dropdown-item>
                        </b-nav-item-dropdown>
                        <b-nav-item @click="toggleMenu" v-if="$route.name !== 'brief'"><font-awesome-icon icon="bars" /></b-nav-item>
                    </b-navbar-nav>
                </b-collapse>
            </b-container>
        </b-navbar>
    </header>
</template>
<script>
    export default {
        data() {
            return {
                authenticated: false,
                dropdown: null,
                website_url: process.env.WEBSITE_URL
            }
        },
        methods: {
            logout () {
                this.$auth.destroyToken()
                this.$router.push('/login')
            },
            toggleMenu (e) {
                e.stopPropagation()
                this.$store.commit('toggleMenu')
            }
        },
        computed: {
            full_name () {
                if( typeof( this.user.id ) === 'undefined' ) {
                    return ''
                }
                return this.user.first_name + ' ' + this.user.last_name
            },
            iframe () {
                return this.$store.state.iframe
            }
        }
    }
</script>



// WEBPACK FOOTER //
// prompts/components/Header.vue